/** Newest recorded completed activity first; preserve roster order for ties/missing dates. */
export function sortAthletesByWorkout<T extends {last_workout_uploaded_at?: string | null}>(athletes: readonly T[]): T[] {
  const timestamp = (athlete: T) => {
    const value = Date.parse(athlete.last_workout_uploaded_at ?? '');
    return Number.isFinite(value) ? value : -Infinity;
  };
  return athletes.map((athlete,index)=>({athlete,index})).sort((a,b)=>{
    const first=timestamp(a.athlete),second=timestamp(b.athlete);
    return first===second ? a.index-b.index : second>first ? 1 : -1;
  }).map(entry=>entry.athlete);
}
